// extracted by mini-css-extract-plugin
module.exports = {"List":"List_List__7AtFr","List_large":"List_List_large__Cs8AZ"};